import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography , Menu , MenuItem ,TextField } from "@mui/material";
import {EditOutlined ,DeleteOutline , History} from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { Box } from '@mui/material';
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";

//Services
import promocodeApi from "Services/Promocode";

//Modals
import PassengerAddModal from "Pages/Modals/Promocode/Create";
import PassengerUpdateModal from "Pages/Modals/Promocode/Update";
import PassengerDeleteDialog from "Pages/Modals/Promocode/Delete";

const Promocode = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );

  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);
  const [currentRowData, setCurrentRowData] = useState({}); // State to hold the current row data
  const [customerId, setCustomerId] = useState("");

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openaction = Boolean(anchorEl);
  const handleClick = (event, rowData) => {
    setCurrentRowData(rowData);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseaction = () => {
    setAnchorEl(null);
  };

  //Modals

  const [addPassenderModal, setAddPassengerModal] = useState(false);
  
  const handleOpenAddPassengerModal = () => {
    setAddPassengerModal(true);
  };

  const handleCloseAddPassengerModal = () => {
    setAddPassengerModal(false);
    getPromocodes();
  };

  const [updatePassenderModal, setUpdatePassengerModal] = useState(false);

  const handleOpenUpdatePassengerModal = (row) => {
    setCustomerId(row?._id);
    setUpdatePassengerModal(true);
    setAnchorEl(null);
  };

  const handleCloseUpdatePassengerModal = () => {
    setUpdatePassengerModal(false);
    getPromocodes();
  };

  const [deletePassengerModal, setdeletePassengerModal] = useState(false);

  const handleOpenDeletePassengerModal = (row) => {
    setCustomerId(row?._id);
    setdeletePassengerModal(true);
    setAnchorEl(null);
  };

  const handleCloseDeleteServiceModal = (row) => {
    setdeletePassengerModal(false);
    getPromocodes();
  };

  // Get Passenger list api
  const getPromocodes = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    const params = { page, limit: pageSize };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    promocodeApi
      .getPromocodeList(params)
      .then(onSuccess, onFailure);
  }, [page, pageSize, demoaccount_id ]);

  useEffect(() => {
    getPromocodes();
  }, [getPromocodes]);

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const handleCopy = () => {
      // Define column widths
      const columnWidths = [5, 15, 25, 15, 15, 15 , 15, 15]; // Adjust widths as needed
  
      // Helper function to pad text to the desired width
      const padText = (text, width) => {
        return (text ?? "").toString().padEnd(width, " ");
      };

      // Create table header
      const header = [
        padText("S.NO", columnWidths[0]),
        padText("Promo Code", columnWidths[1]),
        padText("Discount", columnWidths[2]),
        padText("Discount Type", columnWidths[3]),
        padText("User Type", columnWidths[4]),
        padText("Starting at", columnWidths[5]),
        padText("Expiration", columnWidths[6]),      
        padText("Status", columnWidths[7]),
        padText("Usage Count", columnWidths[8]),                  
      ].join("");
    
      // Create table rows
      const rows = dataRows
        .map((row) =>
          [   
            padText(row.sno, columnWidths[0]),            
            padText(row.promoCode, columnWidths[1]),
            padText(row.discount, columnWidths[2]),
            padText(row.discountType, columnWidths[3]),
            padText(row.discountUserType, columnWidths[4]),
            padText(row.startingAt, columnWidths[5]),
            padText(row.expiresAt, columnWidths[6]),
            padText(row.status, columnWidths[7]),    
            padText(row.use_count, columnWidths[8]),                    
          ].join("")
        )
        .join("\n");
    
      // Combine header and rows
      const formattedContent = [header, rows].join("\n");
    
      // Copy to clipboard
      navigator.clipboard.writeText(formattedContent).then(() => {
        alert("Table copied to clipboard!");
      });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "PromocodeList.xlsx");
  };

  const handleDownloadCSV = () => {
  const csv = Papa.unparse(formatteddatas);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "PromocodeList.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,
      row.promoCode,
      row.discount,
      row.discountUserType,
      row.startingAt,
      row.expiresAt,  
      row.status,            
      row.use_count
    ]);
    doc.autoTable({
      head: [["S.NO","Promo Code","Discount","Discount Type","User Type","Starting at","Expiration","Status","Usage Count" ]],
      body: tableData,
    });
    doc.save("PromocodeList.pdf");
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    promoCode: data?.promoCode,
    discount: data?.discount,
    discountType: data?.discountType,
    discountUserType: data?.discountUserType,
    startingAt: data?.startingAt,
    expiresAt: data?.expiresAt,
    status: data?.status,
    use_count: data?.use_count,
    row: data,
  }));

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "Promo Code":row.promoCode,
    "Discount":row.discount,
    "Discount Type": row.discountType,
    "User Type": row.discountUserType,
    "Starting at": row.startingAt,
    "Expiration": row.expiresAt,
    "Status": row.status,
    "Usage Count": row.use_count,        
  }));

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "promoCode",
      headerName: "Promo Code",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.promoCode}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "discount",
      headerName: "Discount",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.discount}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "discountType",
      headerName: "Discount Type",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
            <Typography variant="body2">{params?.row?.discountType
            ?.toLowerCase()
            .split(/[\s_]+/)
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
            }</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "discountUserType",
      headerName: "User Type",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
            <Typography variant="body2">{params?.row?.discountUserType
            ?.toLowerCase()
            .split(/[\s_]+/)
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
            }</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "startingAt",
      headerName: "Starting At",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{moment(params?.row?.startingAt).format("DD-MM-YYYY")}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "expiresAt",
      headerName: "Expires On",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{moment(params?.row?.expiresAt).format("DD-MM-YYYY")}</Typography>
            </div>
          </>
        );
      },
    },  
{
  field: "status",
  headerName: "Status",
  flex: 1,
  sortable: true,
  renderCell: (params) => {
    const status = params?.row?.status;

    // background color map
    const bgColor =
      status === "VALID"
        ? "#3bdd62" // light green
        : status === "EXPIRED"
        ? "#ef6077" // light red
        : status === "UPCOMING"
        ? "#7fd5e5" // light blue
        : "transparent";

    // text formatting
    const formattedStatus = status
      ?.toLowerCase()
      .split(/[\s_]+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return (
      <div
        style={{
          backgroundColor: bgColor,
          padding: "4px 8px",
          borderRadius: "8px",
          display: "inline-block",
        }}
      >
        <Typography variant="body2">{formattedStatus}</Typography>
      </div>
    );
  },
},    
    
    {
      field: "use_count",
      headerName: "Usage Count",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.use_count}</Typography>
            </div>
          </>
        );
      },
    },       
    {
      field: "actions",
      headerName: "Actions",
      flex:1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const rowData = params?.row?.row;
        return (
          <div className={classes.iconsWrapper}>
            {/* Action Button with Dropdown */}
            <Button
              id="basic-button"
              aria-controls={openaction ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openaction ? "true" : undefined}
              onClick={(e) => handleClick(e, rowData)}
            >
              Action
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openaction}
              onClose={handleCloseaction}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >      
              {/* Edit Option */}
              <MenuItem onClick={() => handleOpenUpdatePassengerModal(currentRowData)}>
                <section className={classes.editIcon}>
                  <EditOutlined />
                  <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
                    Edit
                  </Typography>
                </section>
              </MenuItem>
      
              {/* Delete Option */}
              <MenuItem onClick={() => handleOpenDeletePassengerModal(currentRowData)}>
                <section className={classes.deleteIcon}>
                  <DeleteOutline />
                  <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
                    Delete
                  </Typography>
                </section>
              </MenuItem>
            </Menu>
          </div>
        );
      }
    }
  ];

  return (
    <>
      <Grid container className={classes.root}>
      <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleCopy}>
            COPY
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadExcel}>
            EXCEL
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadCSV}>
            CSV
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadPDF}>
            PDF
          </Button>
        </Grid>       
        <Grid item xs={8} md={8} lg={8} xl={8} className={classes.addBtn}>
          <Button variant="contained" onClick={handleOpenAddPassengerModal}>
            Add Promocode
          </Button>
        </Grid>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
              paginationMode="server"
              rowCount={totalPages}
              filterMode="server"
              onFilterModelChange={(model) => {
                const value = model?.quickFilterValues?.[0] || "";
                //  console.log(value);
                  setSearchText(value);          
              }}
            />
          </section>
        </Grid>
      </Grid>
      <PassengerAddModal
        openDialog={addPassenderModal}
        handleClose={handleCloseAddPassengerModal}
      ></PassengerAddModal>
      <PassengerUpdateModal
        openDialog={updatePassenderModal}
        id={customerId}
        handleClose={handleCloseUpdatePassengerModal}
      ></PassengerUpdateModal>
      <PassengerDeleteDialog
      openDialog={deletePassengerModal}
      id={customerId}
      handleClose={handleCloseDeleteServiceModal}
    ></PassengerDeleteDialog>
    </>
  );
};

export default Promocode;
